import {Stack} from 'shells/layout/stack/stack';

import type {AiStatFragment, AiUserFragment, AiFeatureFragment} from 'nutshell-graphql-types';

import {getSelectedUsageTab} from '../helpers';

import {StatsGrid} from './stats-grid';
import {UsageLeaderboards} from './usage-leaderboards';

export interface UsageStatsSectionProps {
    aiFeatureStats: AiStatFragment[];
    topAiUsers?: AiUserFragment[];
    topAiFeatures?: AiFeatureFragment[];
    isLoadingData: boolean;
    numStatColumns: number;
}

const HOMEPAGE_PRIMARY_STATS_COUNT = 3;
const HOMEPAGE_PRIMARY_STATS_COLUMNS = 3;
const HOMEPAGE_SECONDARY_STATS_COLUMNS = 4;

export function UsageStatsSection(props: UsageStatsSectionProps) {
    const currentPeriod = getSelectedUsageTab(window.location.search);
    const displayPeriod = currentPeriod ? currentPeriod.toLowerCase() : 'week';
    const hasAiOutcomes = NutClientConfig.hasAiOutcomesFF;

    const isHomepage = props.topAiUsers != null;
    const useHomepageLayout = hasAiOutcomes && isHomepage;

    const leaderboards = isHomepage ? (
        <UsageLeaderboards
            topAiUsers={props.topAiUsers}
            topAiFeatures={props.topAiFeatures}
            isLoading={props.isLoadingData}
            displayPeriod={displayPeriod}
            showOutcomeCount={Boolean(hasAiOutcomes)}
        />
    ) : null;

    if (useHomepageLayout) {
        const primaryStats = props.aiFeatureStats.slice(0, HOMEPAGE_PRIMARY_STATS_COUNT);
        const secondaryStats = props.aiFeatureStats.slice(HOMEPAGE_PRIMARY_STATS_COUNT);

        return (
            <Stack spacing={24} isFullWidth={true}>
                <StatsGrid
                    stats={primaryStats}
                    numColumns={HOMEPAGE_PRIMARY_STATS_COLUMNS}
                    isLoading={props.isLoadingData}
                    isPrimary={true}
                    isMonthView={displayPeriod === 'month'}
                />
                {leaderboards}
                <StatsGrid
                    stats={secondaryStats}
                    numColumns={HOMEPAGE_SECONDARY_STATS_COLUMNS}
                    isLoading={props.isLoadingData}
                    isPrimary={false}
                    isMonthView={displayPeriod === 'month'}
                />
            </Stack>
        );
    }

    return (
        <>
            <StatsGrid
                stats={props.aiFeatureStats}
                numColumns={props.numStatColumns}
                isLoading={props.isLoadingData}
                isPrimary={true}
                isMonthView={displayPeriod === 'month'}
            />
            {leaderboards}
        </>
    );
}
